import formSubmissionOverride from './modules/ajaxFormSubmission';

formSubmissionOverride('.filter-form', ".result-container", "pag-number", null, true);
